import api from './api';

export const userService = {
  getUsers: () => api.get('/users'),

  createUser: (data) => api.post('/users', data),

  updateUser: (id, data) => api.put(`/users/${id}`, data),

  deleteUser: (id) => api.delete(`/users/${id}`),

  resetPassword: (id, password) =>
    api.put(`/users/${id}/reset-password`, { password }),
};
